import { Directive, EventEmitter, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[onInit]',
  standalone: true,
})
export class OnInitDirective implements OnInit {
  @Output('onInit') initEvent = new EventEmitter<void>();

  ngOnInit(): void {
    this.initEvent.emit();
  }
}
